<script>
    import _          from 'lodash'
    import validate   from 'validate.js'
    import Item       from '../../shared/Item.svelte'
    import FieldError from '../../shared/FieldError.svelte'

    export let item
    export let active
    export let onUpdate
    export let onRemove
    export let withHeader = true

    const constraints = {
        name         : { 
            presence : { allowEmpty: false, message: "campo obrigatório" } 
        },
        contact      : { 
            presence : { allowEmpty: false, message: "campo obrigatório" }, 
            email    : {                    message: "email inválido"    } 
        }
    }

    function validateItem(it) {
        return validate(it, constraints, { fullMessages: false }) || {}
    }

    function isDirty(item, copy) {
        return ! _.isEqual(item, copy)
    }
</script>

<Item debug={false} 
      bind:item 
      bind:active
      {isDirty} 
      {onUpdate} 
      {onRemove}
      {validateItem} 
      {withHeader}>
    <span slot="header">
        <span class="name">        {item.name}    </span>
        <span class="description"> {item.contact} </span>
    </span>
    <div slot="primary" let:errors>
        <form class="ui big form">
            <div class="field"
                class:error={errors.name}>
                <label>Nome</label>
                <input  bind:value={item.name}
                        type="text"
                        autocomplete="false">
                <FieldError style="label" property={errors['name']}/>
            </div>
            <div class="field"
                class:error={errors.contact}>
                <label>Email</label>
                <div class="ui icon input">
                    <input type="text" bind:value={item.contact}>
                </div>
                <FieldError style="label" property={errors['contact']}/>
            </div>
            <div class="field">
                <div class="ui toggle checkbox">
                    <input type="checkbox" bind:checked={item.international}>
                    <label>Internacional</label>
                </div>
            </div>
        </form>
    </div>
</Item>
<style>
    .form {
        margin: 1em 0;
    }
</style>
